const getColValue = (cell) => {
    return cell.value ? cell.value : '';
};

export default getColValue;